import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#mortgage-rate-table-mini', App);
